if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.addOnform = this.closest('.shopify-section').querySelector('addon-product');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.hasMultiVariants = this.dataset.multiVariants === 'true';
        this.hasMultiVariants = this.closest('.shopify-section').querySelector('product-configurator') ? true : false;
        this.useParentId = this.dataset.useParentId === 'true' || this.dataset.useParentId === undefined;
      }

      connectedCallback() {
        if (this.dataset.translateKlaviyoButton === 'true') {
          this.updateKlaviyoButton();
          this.observeKlaviyoButton();
        }
      }

      updateKlaviyoButton() {
        try {
          if (this.dataset.translateKlaviyoButton !== 'true' || !this.dataset.klaviyoButtonText) return;

          const klaviyoButton = this.querySelector('button[data-a11y-identifier^="bis-button"]');
          if (klaviyoButton) {
            const targetText = this.dataset.klaviyoButtonText;
            if (klaviyoButton.textContent !== targetText) {
              klaviyoButton.textContent = targetText;
            }
          }
        } catch (e) {
          console.error('Error updating Klaviyo button:', e);
        }
      }

      observeKlaviyoButton() {
        if (!window.MutationObserver || this.klaviyoObserver) return;

        this.klaviyoTimeout = null;
        const observer = new MutationObserver(() => {
          if (this.klaviyoTimeout) clearTimeout(this.klaviyoTimeout);
          this.klaviyoTimeout = setTimeout(() => {
            this.updateKlaviyoButton();
          }, 100);
        });

        observer.observe(this, {
          childList: true,
          subtree: true,
        });

        this.klaviyoObserver = observer;
      }

      disconnectedCallback() {
        if (this.klaviyoTimeout) {
          clearTimeout(this.klaviyoTimeout);
          this.klaviyoTimeout = null;
        }
        if (this.klaviyoObserver) {
          this.klaviyoObserver.disconnect();
          this.klaviyoObserver = null;
        }
      }

      addMultipleVariants(mainItemId) {
        console.log('addMultipleVariants');
        const multiVariantSelects =
          this.closest('product-configurator')?.querySelector('product-configurator-products') ||
          this.closest('.shopify-section')?.querySelector('product-configurator');

        if (!multiVariantSelects) {
          return [];
        }

        const items = [];
        const selectedInputs = multiVariantSelects.querySelectorAll('input:checked');
        const selectedSelects = multiVariantSelects.querySelectorAll('select');

        selectedInputs.forEach((input) => {
          items.push({
            quantity: 1,
            id: input.value,
            parent_id: this.useParentId ? mainItemId : undefined,
          });
        });

        selectedSelects.forEach((select) => {
          const selectedOption = select.options[select.selectedIndex];
          if (selectedOption && selectedOption.hasAttribute('data-single-variant') && selectedOption.value) {
            items.push({
              quantity: 1,
              id: selectedOption.value,
              parent_id: this.useParentId ? mainItemId : undefined,
            });
          }
        });

        return items;
      }

      getItems() {
        const formData = JSON.parse(serializeForm(this.form));
        let properties = this.getSelectedProperties(formData);

        // Always include the main item with updated properties for addons
        const mainItem = properties
          ? this.createItemWithProperties(formData, properties)
          : this.createItemFromForm(formData);

        if (this.hasAddons) {
          // Update properties of the main item with addon data
          this.addAddonProperties(mainItem);
        }

        if (this.hasMultiVariants) {
          console.log(mainItem.id);
          const items = this.addMultipleVariants(mainItem.id);
          const productConfigurator = this.closest('.shopify-section').querySelector('product-configurator');
          if (productConfigurator && productConfigurator.dataset.includeMainProduct === 'true') {
            const productTitle = productConfigurator.dataset.productTitle;
            items.forEach((item) => {
              item.properties = {
                ...item.properties,
                'Product': productTitle,
              };
            });
            items.unshift(mainItem);
          }
          return { items };
        } else {
          return { items: [mainItem] };
        }
      }

      getSelectedProperties(formData) {
        if (formData.properties) {
          return Object.entries(formData.properties)
            .filter(([key, value]) => value) // Include only non-empty values
            .reduce((acc, [key, value]) => {
              acc[key] = value;
              return acc;
            }, {});
        }
        return {};
      }

      createItemWithProperties(formData, properties) {
        const item = {
          quantity: formData.quantity,
          id: formData.id,
          properties: {
            ...this.getSelectedProperties({ properties }),
          },
        };
        if (formData.selling_plan) {
          item.selling_plan = formData.selling_plan;
        }
        return item;
      }

      createItemFromForm(formData) {
        const item = {
          quantity: formData.quantity,
          id: formData.id,
        };
        if (formData.selling_plan) {
          item.selling_plan = formData.selling_plan;
        }
        return item;
      }

      addAddonProperties(mainItem) {
        const checkboxes = this.addOnform.querySelectorAll('input[type="radio"]:checked');
        checkboxes.forEach((checkbox) => {
          const addonName = checkbox.name || 'Addon';
          const addonValue = checkbox.value;

          // Add each addon as a custom property
          mainItem.properties[`Addon - ${addonName}`] = addonValue;
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.dataset.type == 'add-to-box') return;

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const items = this.getItems();
        const productFormData = this.getProductFormData(items);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify({
          ...productFormData,
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        });

        console.log(config);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (response.status === 422 && this.dataset.continueSelling) {
                window.location = window.routes.cart_url;
                return;
              }
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      getProductFormData(items) {

        return items;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }
  );
}
